import React from "react"
import ImageLoader from "../../../components/misc/ImageLoader"
import Paper from "material-ui/Paper"
import { amber500 } from "material-ui/styles/colors"
import autobind from "class-autobind"
interface IProps {
    profileImageS3Url: string
    profileImage: string
    readonly: boolean
    onDelete(): void
    onUpload(): void
}
interface IState {
    isHovering: boolean
}

export default class UserProfilePicTile extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            isHovering: false
        }
        autobind(this)
    }

    handleMouseOver() {
        this.setState({ isHovering: true })
    }

    handleMouseOut() {
        this.setState({ isHovering: false })
    }

    render() {
        let opacity = 0
        let deleteIconOpacity = 0
        let actionDisplay = false
        if (this.state.isHovering && !this.props.readonly) {
            opacity = 0.3
            deleteIconOpacity = 1
            actionDisplay = true
        }

        return (
            <div data-intercom-target={"menu-Employees-Select-Profile-Picture"} className="UserProfilePicTile">
                <Paper zDepth={2} style={{ position: "relative", height: "300px" }}>
                    {(this.props.profileImageS3Url || this.props.profileImage) &&
                        <ImageLoader url={this.props.profileImageS3Url} fixedHeight={300} src={"/users/profileimage/" + this.props.profileImage} />
                    }
                    
                    {(!this.props.profileImageS3Url && !this.props.profileImage) &&
                        <div style={{ width: "250px", height: "300px" }} />
                    }
                    <div style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%" }}>
                        <div
                            style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%", background: amber500, opacity: opacity, cursor: !this.props.readonly ? "pointer" : "" }}
                            onMouseOver={this.handleMouseOver}
                            onMouseOut={this.handleMouseOut}
                        />
                        {actionDisplay &&
                            <span
                                className="fa-stack fa-lg"
                                style={{ display: "block", padding: 5, cursor: "pointer" }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                            />
                        }
                        {!this.props.readonly && (this.props.profileImageS3Url || this.props.profileImage) &&
                            <div
                                style={{
                                    color: "#ffffff",
                                    position: "absolute",
                                    right: 0,
                                    top: 0,
                                    padding: 10,
                                    opacity: deleteIconOpacity,
                                    fontSize: 22,
                                    cursor: "pointer"
                                }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                                onClick={this.props.onDelete}
                            >
                                <i className="fa fa-trash" />
                            </div>
                        }
                        {!this.props.readonly &&
                            <div
                                style={{
                                    color: "#ffffff",
                                    position: "absolute",
                                    left: "50%",
                                    top: "50%",
                                    transform: "translate(-50%, -50%)",
                                    padding: 10,
                                    opacity: deleteIconOpacity,
                                    fontSize: 32,
                                    cursor: "pointer"
                                }}
                                onMouseOver={this.handleMouseOver}
                                onMouseOut={this.handleMouseOut}
                                onClick={this.props.onUpload}
                            >
                                <i className="fa fa-camera" />
                            </div>
                        }
                    </div>
                </Paper>
            </div>
        )
    }
}
